import {
    savePaymentMethod,
    fetchPaymentMethods,
    deletePaymentMethod,
} from '../api';
import { showErrorPopup } from './notification-actions';

export const getPaymentMethods = (showLoading = true) => async (dispatch, getState, { mainApi }) => {
    if (showLoading) {
        dispatch({
            type: 'SPLASH_SHOW_LOADING',
            title: '',
        });
    }
    try {
        const { auth } = getState();
        if (auth.user === null) {
            dispatch(showErrorPopup({
                message: 'Error loading payment methods',
                error: 'User not authenticated',
            }));
            return [];
        }
        const res = await fetchPaymentMethods(mainApi);
        if (showLoading) {
            dispatch({
                type: 'SPLASH_HIDE',
            });
        }
        if (res.data.error) {
            dispatch(showErrorPopup({
                message: 'User not authenticated',
                error: res.data.error,
            }));
            return [];
        }
        return res.data;
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error loading payment methods',
            error: err,
        }));
        return [];
    }
};

export const savePaymentMethodAction = postData => async (dispatch, getState, { mainApi }) => {
    dispatch({
        type: 'SPLASH_SHOW_LOADING',
        title: '',
    });
    try {
        const { auth } = getState();
        if (auth.user === null) {
            dispatch(showErrorPopup({
                message: 'Error saving payment method',
                error: 'User not authenticated',
            }));
            return false;
        }
        const res = await savePaymentMethod(mainApi, postData);
        dispatch({
            type: 'SPLASH_HIDE',
        });
        if (res.data.error) {
            dispatch(showErrorPopup({
                message: 'Error saving payment method',
                error: res.data.error,
            }));
            return false;
        }
        return res.data;
    } catch (err) {
        dispatch({
            type: 'SPLASH_HIDE',
        });
        dispatch(showErrorPopup({
            message: 'Error saving payment method',
            error: err,
        }));
        return false;
    }
};

export const deletePlayerCard = cardId => async (dispatch, getState, { mainApi }) => {
    dispatch({
        type: 'SPLASH_SHOW_LOADING',
        title: '',
    });
    try {
        const { auth } = getState();
        if (auth.user === null) {
            dispatch(showErrorPopup({
                message: 'Error deleting player card',
                error: 'User not authenticated',
            }));
            return false;
        }
        const res = await deletePaymentMethod(mainApi, cardId);
        dispatch({
            type: 'SPLASH_HIDE',
        });
        if (res.data.error) {
            dispatch(showErrorPopup({
                message: 'Error deleting player card',
                error: res.data.error,
            }));
            return false;
        }
        return true;
    } catch (err) {
        dispatch({
            type: 'SPLASH_HIDE',
        });
        dispatch(showErrorPopup({
            message: 'Error deleting player card',
            error: err,
        }));
        return false;
    }
};
